const Motto = () => {
	return (
		<section className="motto">
			<div className="motto__box">
				<blockquote className="motto__text">
					Sukces to świadomość, że twoje dzieło ma znaczenie i pozytywnie wpływa
					na innych.
				</blockquote>
				<cite className="motto__author">Helen Keller</cite>
			</div>
		</section>
	);
};

export default Motto;
